<template>
	<div v-if="$route.meta.publicLayout">
		<div class="layout-main">
			<router-view />
		</div>
	</div>
	<div v-else-if="$route.meta.publicLayoutWithLogo">
		<div class="p-grid p-nogutter public-header">
			<div class="p-col-4 p-md-1">
				<router-link to="/">
					<img class="logo" alt="Tirolibre" :src="commonService.getTirolibreLogoUrl('black')" />
				</router-link>
			</div>
			<div class="p-col-2 p-offset-4 p-md-offset-10 p-md-1 language-selector">
				<LanguageSelector v-on:languageChanged="onLanguageChanged" />
			</div>
		</div>

		<div class="layout-public-main">
			<router-view ref="view" />
		</div>
	</div>
	<div v-else-if="$route.meta.publicLayout == false" :class="containerClass" @click="onWrapperClick">
		<AppTopBar @menu-toggle="onMenuToggle" v-on:languageChanged="onLanguageChanged" />

		<transition name="layout-sidebar">
			<div :class="sidebarClass" @click="onSidebarClick" v-show="isSidebarVisible()">
				<div class="layout-logo">
					<router-link to="/">
						<img class="logo" alt="Tirolibre" :src="commonService.getTirolibreLogoUrl('white')" />
					</router-link>
				</div>

				<AppProfile ref="appProfileView" />
				<AppMenu v-if="authService.getUserId() == $whatchatTirolibreBaseUserId" :model="menuPaolo" @menuitem-click="onMenuItemClick" />
				<AppMenu v-else-if="authService.getUserProfile() == $agentTirolibre" :model="menuTirolibre" @menuitem-click="onMenuItemClick" />
				<AppMenu v-else-if="authService.getUserProfile() == $agentProfileId" :model="menuAgent" @menuitem-click="onMenuItemClick" />
				<AppMenu v-else-if="authService.getUserProfile() == $playerProfileId" :model="menuPlayer" @menuitem-click="onMenuItemClick" />
				<AppMenu v-else-if="authService.getUserProfile() == $teamProfileId" :model="menuTeam" @menuitem-click="onMenuItemClick" />
				<AppMenu v-else-if="authService.getUserProfile() == $coachingStaffProfileId" :model="menuCoachingStaff" @menuitem-click="onMenuItemClick" />
			</div>
		</transition>

		<div class="layout-main">
			<router-view ref="view" v-on:avatarChanged="avatarChanged()" />
		</div>

		<AppFooter />
	</div>
	<div v-else>
	</div>
</template>

<script>
import AppTopBar from "./AppTopbar.vue";
import AppProfile from "./AppProfile.vue";
import AppMenu from "./AppMenu.vue";
import AppFooter from "./AppFooter.vue";
import CommonService from "@/service/CommonService";
import AuthService from "@/service/AuthService";
import Vue from "vue";

export default {
	components: {
		AppTopBar: AppTopBar,
		AppProfile: AppProfile,
		AppMenu: AppMenu,
		AppFooter: AppFooter,
	},
	data() {
		return {
			layoutMode: "static",
			layoutColorMode: "dark",
			staticMenuInactive: false,
			overlayMenuActive: false,
			mobileMenuActive: false,
			menuPaolo: [
				// {
				// 	label: this.$t("Dashboard"),
				// 	icon: "pi pi-fw pi-home",
				// 	to: "/"
				// },
				{
					label: this.$t("Portfolio"),
					icon: "pi pi-fw pi-clone",
					items: [
						{
							label: this.$t("PlayerList"),
							icon: "pi pi-fw pi-clone",
							command: () => {
								window.location = "#/portfolio";
							},
						},
						{
							label: this.$t("CoachingStaffList"),
							icon: "pi pi-fw pi-clone",
							command: () => {
								window.location = "#/portfolioCoaching";
							},
						},
					],
				},
				{
					label: "KPIs",
					icon: "pi pi-fw pi-money-bill",
					items: [
						{
							label: "KPIs",
							icon: "pi pi-fw pi-plus-circle",
							command: () => {
								window.location = "#/KPIs";
							},
						},
					],
				},
				{
					label: this.$t("Negotiation"),
					icon: "pi pi-fw pi-money-bill",
					items: [
						{
							label: this.$t("CreateNegotiation"),
							icon: "pi pi-fw pi-plus-circle",
							command: () => {
								window.location = "#/negotiation";
							},
						},
						{
							label: this.$t("ListNegotiations"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/negotiations";
							},
						},
						{
							label: this.$t("Report"),
							icon: "pi pi-fw pi-list",
							command: () => {
								window.location = "#/negotiationsReport";
							},
						},
					],
				},
				{
					label: this.$t("Offer.Offer"),
					icon: "pi pi-fw pi-thumbs-up",
					items: [
						{
							label: this.$t("Offer.CreateOffer"),
							icon: "pi pi-fw pi-plus-circle",
							command: () => {
								window.location = "#/offer";
							},
						},
						{
							label: this.$t("Offer.ListOffers"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/offers";
							},
						},
					],
				},
				{
					label: this.$t("PlayerRequest"),
					icon: "pi pi-fw pi-eye",
					items: [
						{
							label: this.$t("CreatePlayerRequest"),
							icon: "pi pi-fw pi-plus-circle",
							command: () => {
								window.location = "#/request";
							},
						},
						{
							label: this.$t("ListPlayerRequest"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/requests";
							},
						},
						{
							label: this.$t("CandidatesList"),
							icon: "pi pi-fw pi-users",
							command: () => {
								window.location = "#/requestsCandidates";
							},
						},
					],
				},
				{
					label: this.$t("Teams"),
					icon: "pi pi-fw pi-list",
					items: [
						{
							label: this.$t("TeamsList"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/teams";
							},
						},
						{
							label: this.$t("CoachingStaffList"),
							icon: "pi pi-fw pi-eye",
							command: () => {
								window.location = "#/teamContacts";
							},
						},
					],
				},
				{
					label: this.$t("MatchingSystem"),
					icon: "pi pi-fw pi-list",
					items: [
						{
							label: this.$t("Exact"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/exactMatch";
							},
						},
						{
							label: this.$t("Potential"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/potentialMatch";
							},
						},
						{
							label: this.$t("Partial"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/partialMatch";
							},
						},
					],
				},
				{
					label: this.$t("invoices"),
					icon: "pi pi-fw pi-money-bill",
					items: [
						{
							label: this.$t("invoices"),
							icon: "pi pi-fw pi-money-bill",
							command: () => {
								window.location = "#/invoicesPlayers";
							},
						},
						{
							label: this.$t("Teams"),
							icon: "pi pi-fw pi-money-bill",
							command: () => {
								window.location = "#/invoicesTeams";
							},
						},
					],
				},
				{
					label: this.$t("NegotiationRoom"),
					icon: "pi pi-fw pi-comments",
					command: () => {
						window.location = "#/negotiationRoom";
					},
				},
			],
			menuTirolibre: [
				// {
				// 	label: this.$t("Dashboard"),
				// 	icon: "pi pi-fw pi-home",
				// 	to: "/"
				// },
				{
					label: this.$t("Portfolio"),
					icon: "pi pi-fw pi-clone",
					items: [
						{
							label: this.$t("PlayerList"),
							icon: "pi pi-fw pi-clone",
							command: () => {
								window.location = "#/portfolio";
							},
						},
						{
							label: this.$t("CoachingStaffList"),
							icon: "pi pi-fw pi-clone",
							command: () => {
								window.location = "#/portfolioCoaching";
							},
						},
					],
				},
				{
					label: "KPIs",
					icon: "pi pi-fw pi-money-bill",
					items: [
						{
							label: "KPIs",
							icon: "pi pi-fw pi-plus-circle",
							command: () => {
								window.location = "#/KPIs";
							},
						},
					],
				},
				{
					label: this.$t("Negotiation"),
					icon: "pi pi-fw pi-money-bill",
					items: [
						{
							label: this.$t("CreateNegotiation"),
							icon: "pi pi-fw pi-plus-circle",
							command: () => {
								window.location = "#/negotiation";
							},
						},
						{
							label: this.$t("ListNegotiations"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/negotiations";
							},
						},
						{
							label: this.$t("Report"),
							icon: "pi pi-fw pi-list",
							command: () => {
								window.location = "#/negotiationsReport";
							},
						},
					],
				},
				{
					label: this.$t("Offer.ListOffers"),
					icon: "pi pi-fw pi-thumbs-up",
					command: () => {
						window.location = "#/offers";
					},
				},
				{
					label: this.$t("PlayerRequest"),
					icon: "pi pi-fw pi-eye",
					items: [
						{
							label: this.$t("CreatePlayerRequest"),
							icon: "pi pi-fw pi-plus-circle",
							command: () => {
								window.location = "#/request";
							},
						},
						{
							label: this.$t("ListPlayerRequest"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/requests";
							},
						},
						{
							label: this.$t("CandidatesList"),
							icon: "pi pi-fw pi-users",
							command: () => {
								window.location = "#/requestsCandidates";
							},
						},
					],
				},
				{
					label: this.$t("Teams"),
					icon: "pi pi-fw pi-list",
					items: [
						{
							label: this.$t("TeamsList"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/teams";
							},
						},
						{
							label: this.$t("CoachingStaffList"),
							icon: "pi pi-fw pi-eye",
							command: () => {
								window.location = "#/teamContacts";
							},
						},
					],
				},
				{
					label: this.$t("MatchingSystem"),
					icon: "pi pi-fw pi-list",
					items: [
						{
							label: this.$t("Exact"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/exactMatch";
							},
						},
						{
							label: this.$t("Potential"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/potentialMatch";
							},
						},
						{
							label: this.$t("Partial"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/partialMatch";
							},
						},
					],
				},
				{
					label: this.$t("invoices"),
					icon: "pi pi-fw pi-money-bill",
					items: [
						{
							label: this.$t("invoices"),
							icon: "pi pi-fw pi-money-bill",
							command: () => {
								window.location = "#/invoicesPlayers";
							},
						},
						{
							label: this.$t("Teams"),
							icon: "pi pi-fw pi-money-bill",
							command: () => {
								window.location = "#/invoicesTeams";
							},
						},
					],
				},
				{
					label: this.$t("NegotiationRoom"),
					icon: "pi pi-fw pi-comments",
					command: () => {
						window.location = "#/negotiationRoom";
					},
				},
			],
			menuAgent: [
				// {
				// 	label: this.$t("Dashboard"),
				// 	icon: "pi pi-fw pi-home",
				// 	to: "/"
				// },
				{
					label: this.$t("Portfolio"),
					icon: "pi pi-fw pi-clone",
					items: [
						{
							label: this.$t("PlayerList"),
							icon: "pi pi-fw pi-clone",
							command: () => {
								window.location = "#/portfolio";
							},
						},
						{
							label: this.$t("CoachingStaffList"),
							icon: "pi pi-fw pi-clone",
							command: () => {
								if (
									this.authService.getUserRole() ==
									Vue.prototype.$agentTirolibre
								)
									window.location = "#/portfolioCoaching";
							},
						},
					],
				},
				{
					label: "KPIs",
					icon: "pi pi-fw pi-money-bill",
					items: [
						{
							label: "KPIs",
							icon: "pi pi-fw pi-plus-circle",
							command: () => {
								if (
									this.authService.getUserRole() ==
									Vue.prototype.$agentTirolibre
								)
									window.location = "#/KPIs";
							},
						},
					],
				},
				{
					label: this.$t("Negotiation"),
					icon: "pi pi-fw pi-money-bill",
					items: [
						{
							label: this.$t("CreateNegotiation"),
							icon: "pi pi-fw pi-plus-circle",
							command: () => {
								window.location = "#/negotiation";
							},
						},
						{
							label: this.$t("ListNegotiations"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/negotiations";
							},
						},
						{
							label: this.$t("Report"),
							icon: "pi pi-fw pi-list",
							command: () => {
								if (
									this.authService.getUserRole() ==
									Vue.prototype.$agentTirolibre
								)
									window.location = "#/negotiationsReport";
							},
						},
					],
				},
				{
					label: this.$t("Offer.ListOffers"),
					icon: "pi pi-fw pi-thumbs-up",
					command: () => {
						window.location = "#/offers";
					},
				},
				{
					label: this.$t("PlayerRequest"),
					icon: "pi pi-fw pi-eye",
					items: [
						{
							label: this.$t("CreatePlayerRequest"),
							icon: "pi pi-fw pi-plus-circle",
							command: () => {
								window.location = "#/request";
							},
						},
						{
							label: this.$t("ListPlayerRequest"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/requests";
							},
						},
						{
							label: this.$t("CandidatesList"),
							icon: "pi pi-fw pi-users",
							command: () => {
								window.location = "#/requestsCandidates";
							},
						},
					],
				},
				{
					label: this.$t("Teams"),
					icon: "pi pi-fw pi-list",
					items: [
						{
							label: this.$t("TeamsList"),
							icon: "pi pi-fw pi-search",
							command: () => {
								if (
									this.authService.getUserRole() ==
									Vue.prototype.$agentTirolibre
								)
									window.location = "#/teams";
							},
						},
						{
							label: this.$t("CoachingStaffList"),
							icon: "pi pi-fw pi-eye",
							command: () => {
								if (
									this.authService.getUserRole() ==
									Vue.prototype.$agentTirolibre
								)
									window.location = "#/teamContacts";
							},
						},
					],
				},
				{
					label: this.$t("MatchingSystem"),
					icon: "pi pi-fw pi-list",
					items: [
						{
							label: this.$t("Exact"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/exactMatch";
							},
						},
						{
							label: this.$t("Potential"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/potentialMatch";
							},
						},
						{
							label: this.$t("Partial"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/partialMatch";
							},
						},
					],
				},
				{
					label: this.$t("invoices"),
					icon: "pi pi-fw pi-money-bill",
					items: [
						{
							label: this.$t("invoices"),
							icon: "pi pi-fw pi-money-bill",
							command: () => {
								window.location = "#/invoicesPlayers";
							},
						},
						{
							label: this.$t("Teams"),
							icon: "pi pi-fw pi-money-bill",
							command: () => {
								if (
									this.authService.getUserRole() ==
									Vue.prototype.$agentTirolibre
								)
									window.location = "#/invoicesTeams";
							},
						},
					],
				},
				{
					label: this.$t("NegotiationRoom"),
					icon: "pi pi-fw pi-comments",
					command: () => {
						window.location = "#/negotiationRoom";
					},
				},
			],
			menuPlayer: [
				{
					label: this.$t("Dashboard"),
					icon: "pi pi-fw pi-clone",
					command: () => {
						window.location = "#/procura";
					},
				},
				{
					label: this.$t("ListNegotiations"),
					icon: "pi pi-fw pi-money-bill",
					command: () => {
						window.location = "#/negotiations";
					},
				},
                {
					label: this.$t("Contract"),
					icon: "pi pi-fw pi-thumbs-up",
					command: () => {
								window.location = "#/contract";
					},
				},
				{
					label: this.$t("Offer.ListOffers"),
					icon: "pi pi-fw pi-thumbs-up",
					command: () => {
								window.location = "#/offers";
					},
				},
				{
					label: this.$t("Market"),
					icon: "pi pi-fw pi-eye",
					command: () => {
						window.location = "#/requests";
					},
				},
				{
					label: this.$t("MatchingSystem"),
					icon: "pi pi-fw pi-list",
					items: [
						{
							label: this.$t("Exact"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/exactMatch";
							},
						},
						{
							label: this.$t("Potential"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/potentialMatch";
							},
						},
						{
							label: this.$t("Partial"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/partialMatch";
							},
						},
					],
				},
				{
					label: this.$t("invoices"),
					icon: "pi pi-fw pi-money-bill",
					command: () => {
						window.location = "#/invoicesPlayers";
					},
				},
				{
					label: this.$t("NegotiationRoom"),
					icon: "pi pi-fw pi-comments",
					command: () => {
						window.location = "#/negotiationRoom";
					},
				},
			],
			menuTeam: [
				{
					label: this.$t("Portfolio"),
					icon: "pi pi-fw pi-clone",
					command: () => {
						window.location = "#/portfolio";
					},
				},
				{
					label: this.$t("Negotiation"),
					icon: "pi pi-fw pi-money-bill",
					items: [
						{
							label: this.$t("PlayerList"),
							icon: "pi pi-fw pi-clone",
							command: () => {
								window.location = "#/playersList";
							},
						},
						// {
						// 	label: this.$t("CoachingStaffList"),
						// 	icon: "pi pi-fw pi-clone",
						// 	command: () => {
						// 		window.location = "#/coachingStaffList";
						// 	},
						// },
						{
							label: this.$t("ListNegotiations"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/negotiations";
							},
						},
					],
				},
				{
					label: this.$t("Offer.Offer"),
					icon: "pi pi-fw pi-thumbs-up",
					items: [
						{
							label: this.$t("Offer.CreateOffer"),
							icon: "pi pi-fw pi-plus-circle",
							command: () => {
								window.location = "#/offer";
							},
						},
						{
							label: this.$t("Offer.ListOffers"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/offers";
							},
						},
					],
				},
				{
					label: this.$t("PlayerRequest"),
					icon: "pi pi-fw pi-eye",
					items: [
						{
							label: this.$t("CreatePlayerRequest"),
							icon: "pi pi-fw pi-plus-circle",
							command: () => {
								window.location = "#/request";
							},
						},
						{
							label: this.$t("ListPlayerRequest"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/requests";
							},
						},
						{
							label: this.$t("CandidatesList"),
							icon: "pi pi-fw pi-users",
							command: () => {
								window.location = "#/requestsCandidates";
							},
						},
					],
				},
				{
					label: this.$t("invoices"),
					icon: "pi pi-fw pi-money-bill",
					items: [
						{
							label: this.$t("Teams"),
							icon: "pi pi-fw pi-money-bill",
							command: () => {
								window.location = "#/invoicesTeams";
							},
						},
					],
				},
				{
					label: this.$t("NegotiationRoom"),
					icon: "pi pi-fw pi-comments",
					command: () => {
						window.location = "#/negotiationRoom";
					},
				},
			],
			menuCoachingStaff: [
				{
					label: this.$t("Portfolio"),
					icon: "pi pi-fw pi-clone",
					command: () => {
						window.location = "#/portfolio";
					},
				},
				{
					label: this.$t("Negotiation"),
					icon: "pi pi-fw pi-money-bill",
					items: [
						{
							label: this.$t("CreateNegotiation"),
							icon: "pi pi-fw pi-plus-circle",
							command: () => {
								//window.location = "#/negotiation";
							},
						},
						{
							label: this.$t("ListNegotiations"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/negotiations";
							},
						},
					],
				},
				{
					label: this.$t("Offer.ListOffers"),
					icon: "pi pi-fw pi-thumbs-up",
					command: () => {
								window.location = "#/offers";
					},
				},
				{
					label: this.$t("PlayerRequest"),
					icon: "pi pi-fw pi-eye",
					items: [
						{
							label: this.$t("CreatePlayerRequest"),
							icon: "pi pi-fw pi-plus-circle",
							command: () => {
								//window.location = "#/request";
							},
						},
						{
							label: this.$t("ListPlayerRequest"),
							icon: "pi pi-fw pi-search",
							command: () => {
								window.location = "#/requests";
							},
						},
						{
							label: this.$t("CandidatesList"),
							icon: "pi pi-fw pi-users",
							command: () => {
								//window.location = "#/requestsCandidates";
							},
						},
					],
				},
				{
					label: this.$t("NegotiationRoom"),
					icon: "pi pi-fw pi-comments",
					command: () => {
						window.location = "#/negotiationRoom";
					},
				},
			],
		};
	},
	commonService: null,
	authService: null,
	created() {
		this.commonService = new CommonService();
		this.authService = new AuthService();
	},
	watch: {
		$route(to, from) {
			// if (window.innerWidth > 991) { // is not mobile
			if (to.path.includes("negotiationRoom"))
				// disable scroll on chat
				document.documentElement.style.overflow = "hidden";
			else {
				if (window.innerWidth > 991)
					// is not mobile
					document.documentElement.style.overflow = "auto";
				else document.documentElement.style.overflow = "unset";
			}
			// }

			this.menuActive = false;
			this.$toast.removeAllGroups();
		},
	},
	methods: {
		avatarChanged() {
			this.$refs.appProfileView.avatarChanged();
		},
		onLanguageChanged() {
			this.$refs.view.languageChanged();
		},
		onWrapperClick() {
			if (!this.menuClick) {
				this.overlayMenuActive = false;
				this.mobileMenuActive = false;
			}

			this.menuClick = false;
		},
		onMenuToggle() {
			this.menuClick = true;

			if (this.isDesktop()) {
				if (this.layoutMode === "overlay") {
					this.overlayMenuActive = !this.overlayMenuActive;
				} else if (this.layoutMode === "static") {
					this.staticMenuInactive = !this.staticMenuInactive;
				}
			} else {
				this.mobileMenuActive = !this.mobileMenuActive;
			}

			event.preventDefault();
		},
		onSidebarClick() {
			this.menuClick = true;
		},
		onMenuItemClick(event) {
			if (event.item && !event.item.items) {
				this.overlayMenuActive = false;
				this.mobileMenuActive = false;
			}
		},
		addClass(element, className) {
			if (element.classList) element.classList.add(className);
			else element.className += " " + className;
		},
		removeClass(element, className) {
			if (element.classList) element.classList.remove(className);
			else
				element.className = element.className.replace(
					new RegExp(
						"(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
						"gi"
					),
					" "
				);
		},
		isDesktop() {
			return window.innerWidth > 1024;
		},
		isSidebarVisible() {
			if (this.isDesktop()) {
				if (this.layoutMode === "static")
					return !this.staticMenuInactive;
				else if (this.layoutMode === "overlay")
					return this.overlayMenuActive;
				else return true;
			} else {
				return true;
			}
		},
	},
	computed: {
		containerClass() {
			return [
				"layout-wrapper",
				{
					"layout-overlay": this.layoutMode === "overlay",
					"layout-static": this.layoutMode === "static",
					"layout-static-sidebar-inactive":
						this.staticMenuInactive && this.layoutMode === "static",
					"layout-overlay-sidebar-active":
						this.overlayMenuActive && this.layoutMode === "overlay",
					"layout-mobile-sidebar-active": this.mobileMenuActive,
				},
			];
		},
		sidebarClass() {
			return [
				"layout-sidebar",
				{
					"layout-sidebar-dark": this.layoutColorMode === "dark",
					"layout-sidebar-light": this.layoutColorMode === "light",
				},
			];
		},
		// logo() {
		// 	return "assets/layout/images/logo.png";
		// }
	},
	beforeUpdate() {
		if (this.mobileMenuActive)
			this.addClass(document.body, "body-overflow-hidden");
		else this.removeClass(document.body, "body-overflow-hidden");
	},
};
</script>

<style lang="scss">
@import "./App.scss";
</style>
